import PlayerRow from './PlayerRow';

export default PlayerRow;
